import { render, staticRenderFns } from "./AssetDataTable.vue?vue&type=template&id=05bf8fe4&scoped=true"
import script from "./AssetDataTable.vue?vue&type=script&lang=js"
export * from "./AssetDataTable.vue?vue&type=script&lang=js"
import style0 from "./AssetDataTable.vue?vue&type=style&index=0&id=05bf8fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf8fe4",
  null
  
)

export default component.exports